import { StatisticsController } from 'api/controllers/StatisticsController';
import { StatsParams } from 'api/controllers/typings';
import { useQuery } from 'react-query';
import { GET_VOTES_CAST_STATS } from '../queryKeys';

export function useGetVotesCastStats(params: StatsParams) {
  return useQuery([GET_VOTES_CAST_STATS, params], () => StatisticsController.getVotesCastStats(params));
}
